import { cn } from '../../lib/cn';
import { initials } from '../../lib/format';

type Props = {
  name?: string | null;
  src?: string | null;
  size?: number;
  className?: string;
  /** Показати як «не призначено». */
  empty?: boolean;
  title?: string;
};

/** Аватар працівника: фото з Google або ініціали на нейтральному тлі (колір не несе значення). */
export function Avatar({ name, src, size = 24, className, empty, title }: Props) {
  const font = size <= 20 ? 'text-[9px]' : size <= 28 ? 'text-[11px]' : 'text-meta';
  if (empty) {
    return (
      <span
        title={title ?? 'Не призначено'}
        className={cn('inline-flex shrink-0 items-center justify-center rounded-full border border-dashed border-line-input text-fg-3', className)}
        style={{ width: size, height: size }}
        aria-hidden
      />
    );
  }
  return (
    <span
      title={title ?? name ?? undefined}
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-surface-3 font-semibold text-fg-2 select-none',
        font,
        className,
      )}
      style={{ width: size, height: size }}
      aria-hidden
    >
      {src ? <img src={src} alt="" className="size-full object-cover" referrerPolicy="no-referrer" /> : initials(name)}
    </span>
  );
}
